import defaultSettings from '../settings';

const title = defaultSettings.title || '仙海区智慧党建大数据平台'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
